<ng-container [ngSwitch]="htmlElement">
  <ng-container *ngSwitchCase="'TR'">
    <td colspan="100">
      <div class="d-flex align-items-center" style="height: 170px;">
        <div class="card uploadWrapper h-100 m-0 mr-2 w-50">
          <!-- Handle Link click -->
          <app-attachment-url-upload></app-attachment-url-upload>
        </div>
        <div class="card uploadWrapper h-100 m-0 ml-2 w-50">
          <sb-comp-file-upload [uploadType]="'attachment'"></sb-comp-file-upload>
        </div>
      </div>
    </td>
  </ng-container>
  <ng-container *ngSwitchDefault>
    <div class="card height-fluid height-fluid-half uploadWrapper">
      <!-- Handle Link click -->
      <app-attachment-url-upload></app-attachment-url-upload>
    </div>

    <div [ngClass]="{'box-dragover': isDragOver}" class="card height-fluid height-fluid-half uploadWrapper">
      <sb-comp-file-upload (isDragOverEmitter)="isDragOver = $event" [uploadType]="'attachment'"></sb-comp-file-upload>
    </div>

  </ng-container>
</ng-container>
